import { render, staticRenderFns } from "./VLetForm.vue?vue&type=template&id=563ae554"
import script from "./VLetForm.vue?vue&type=script&lang=js"
export * from "./VLetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports